export default [
  { name: 'Code', prop: 'code', type: 'text' },
  { name: 'Flat Amount', prop: 'flat_amount', type: 'number' },
  { name: 'Percent Amount', prop: 'percent_amount', type: 'number' },
  { name: 'Usage Limit', prop: 'usage_limit', type: 'number' },
  { name: 'Is Redeemable', prop: 'is_redeemable', type: 'checkbox', format: 'bool' },
  { name: 'Available At', prop: 'available_at', type: 'date' },
  { name: 'Expires At', prop: 'expires_at', type: 'date' }
]
